import type { GdprConfig } from '../types';

export function createSidebarHTML(config: GdprConfig): string {
    const t = config.translations;
    const policyLink = config.cookie_policy_link;
    const types = config.type_preference;

    let preferenceSections = '';

    if (types.preference) {
        preferenceSections += createToggleSection(
            'gdpr-cookie-set-preferences', 'preference',
            t.preferences_title, t.preferences_text
        );
    }

    if (types.stats) {
        preferenceSections += createToggleSection(
            'gdpr-cookie-set-statistics', 'stats',
            t.statistics_title, t.statistics_text
        );
    }

    if (types.marketing) {
        preferenceSections += createToggleSection(
            'gdpr-cookie-set-marketing', 'marketing',
            t.marketing_title, t.marketing_text
        );
    }

    return `<div id="gdprSidebar" class="fixed z-[9999] h-screen pt-4 px-4 pb-16 overflow-y-auto bg-gray-50 border-r border-r-gray-100 w-full max-w-sm hidden" tabindex="-1" aria-label="GdprSidebar">

    <strong id="drawer-label" class="inline-flex items-center mb-3 fluid-text-xs font-semibold uppercase text-neutral-500">
        ${t.site_uses_cookies}
    </strong>

    <div class="flex flex-row flex-wrap basis-full w-full fluid-text-xs leading-relaxed text-neutral-500">
        <p>${t.sidebar_text} <a href="${policyLink}" title="Cookie policy" class="text-neutral-700 underline">${t.cookie_policy}</a></p>
    </div>

    <div class="flex flex-row flex-wrap basis-full w-full mt-4 mb-4 pb-4 border-b-[1px] border-b-gray-200">

        <ul class="flex flex-row flex-wrap basis-full w-full list-none">

            <li class="flex flex-row basis-6/12 w-6/12 pr-1">

                <button type="button" class="btn-dialog-gdpr block w-full justify-center font-medium rounded fluid-text-xs uppercase px-5 py-2.5 text-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-0 focus:outline-none" data-action="decline" data-parent="gdprSidebar">
                    ${t.decline_all}
                </button>

            </li>

            <li class="flex flex-row basis-6/12 w-6/12 pl-1">

                <button type="button" class="btn-dialog-gdpr block w-full justify-center font-medium rounded fluid-text-xs uppercase px-5 py-2.5 text-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-0 focus:outline-none" data-action="accept" data-parent="gdprSidebar">
                    ${t.accept_all}
                </button>

            </li>

        </ul>

    </div>

    <div class="flex flex-row flex-wrap basis-full w-full">

        <div class="flex flex-row flex-wrap basis-full w-full">

            <div class="flex flex-row flex-wrap basis-full w-full justify-between mb-3">

                <strong class="fluid-text-xs font-semibold uppercase text-neutral-500">
                    ${t.necessary_title}
                </strong>

            </div>

            <p class="fluid-text-xs leading-relaxed text-neutral-500">
                ${t.necessary_text}
            </p>

        </div>

        ${preferenceSections}

    </div>

    <div class="fixed bottom-0 left-0 flex flex-row flex-wrap basis-full w-full max-w-sm h-14 items-center px-4 justify-end bg-white border-t-[1px] border-t-gray-200">

        <button type="button" class="btn-dialog-gdpr inline-block justify-center font-medium rounded fluid-text-xs uppercase px-5 py-2.5 text-center text-white bg-sky-700 hover:bg-sky-800 focus:ring-0 focus:outline-none" data-action="save-customize" data-parent="gdprSidebar">
            ${t.save_preference}
        </button>

    </div>

</div>`;
}

function createToggleSection(id: string, dataType: string, title: string, text: string): string {
    return `
        <div class="flex flex-row flex-wrap basis-full w-full mt-4 pt-4 border-t-[1px] border-t-gray-200">

            <div class="flex flex-row flex-wrap basis-full w-full justify-between items-center mb-3">

                <strong class="fluid-text-xs font-semibold uppercase text-neutral-500">
                    ${title}
                </strong>

                <label class="inline-flex relative items-center cursor-pointer">
                    <input type="checkbox" id="${id}" name="${id}" class="checkbox-gdpr sr-only peer" value="1" data-type="${dataType}" />
                    <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-0 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                </label>

            </div>

            <p class="fluid-text-xs leading-relaxed text-neutral-500">
                ${text}
            </p>

        </div>`;
}
